module.exports = __webpack_public_path__ + "img/ewm_sample.32a69c4d.png";